module.exports = __webpack_public_path__ + "img/parallax.7547704c.jpeg";